import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux'

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'

import { MerchantScrubberUploadsTable } from '../../../components/MerchantScrubber';
import { MerchantScrubberDialog } from '../../../components/MerchantScrubber';

import { 
  CircularProgress,
  Backdrop,
  Card,
  Divider,
  Tabs,
  Tab,
  Typography,
  Box,
  AppBar
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const MerchantScrubberImportList = props => {
  const classes = useClasses(styles);
  
  const { 
    onFetchMerchantScrubberImports,
    merchant_scrubber_imports,
    token,
    loading_imports,
    pagination,
    account_id,
    plan_level,
    onOpenMerchantScrubberDialog
  } = props
  
  // let merchant_scrubbers = props.merchant_scrubbers
  // let loading = props.loading

  const [value, setValue] = useState(0);

  useEffect(() => {
    onFetchMerchantScrubberImports(account_id);
  }, [onFetchMerchantScrubberImports, account_id])

  


  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </Typography>
    );
  }

  let merchantScrubberUploadsTable = (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )

  const handleAddMerchantSubscriptionClick = (event) => {
    onOpenMerchantScrubberDialog();
  }
  
  if(!loading_imports){
    merchantScrubberUploadsTable = (
      <MerchantScrubberUploadsTable
        merchant_scrubber_uploads={merchant_scrubber_imports}
        plan_level={plan_level}
        onAddMerchantScrubberClick={handleAddMerchantSubscriptionClick}
      />
    )
  }
  
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Card>
          <Card>
            <Divider />
            {merchantScrubberUploadsTable}
          </Card>
        </Card>
      </div>
      <MerchantScrubberDialog
        accountId={account_id}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    account_id: state.auth.user.account_resource_id,
    loading_imports: state.merchantScrubberImport.loading,
    merchant_scrubber_imports: state.merchantScrubberImport.merchant_scrubber_imports,
    plan_level: state.auth.user.plan_level
  }
}

const mapDispatchToProps = dispatch => {
  return {
   onFetchMerchantScrubberImports: (account_id) => dispatch(actions.fetchMerchantScrubberImports(account_id)),
   onOpenMerchantScrubberDialog: () => dispatch(actions.openMerchantScrubberDialog()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MerchantScrubberImportList, axios))